var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDryer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M30.038 32.414c0 .6-.488 1.085-1.087 1.085H10.586a1.086 1.086 0 0 1-1.087-1.085V8.586c0-.6.487-1.086 1.086-1.086h18.366c.6 0 1.087.487 1.087 1.085v23.83ZM9.35 14.486h20.673"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M26.731 11.875a.5.5 0 0 1 .999 0 .498.498 0 1 1-.999 0ZM23.713 11.875a.5.5 0 1 1 .998 0 .5.5 0 0 1-.998 0ZM14.786 11.875a.5.5 0 0 1 .999 0 .498.498 0 1 1-.999 0ZM11.768 11.875a.5.5 0 1 1 .998 0 .5.5 0 0 1-.998 0ZM18.187 10.993a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM26.165 29.898h-9.304a3.49 3.49 0 0 1-3.488-3.49v-4.651a3.49 3.49 0 0 1 3.488-3.488h9.304v11.629ZM15.785 22.023v4.12"
}))));
export default SvgDryer;